export const distinct = (array: any[]) => {
    return Array.from(
        array.reduce((set, e) => set.add(e), new Set())
    )
}

export const DeepCopy = (value: any) => Object.assign({}, value);

export const DeepCopyArray = (value: any[]) => JSON.parse(JSON.stringify(value));


export function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }